export default "__VITE_ASSET__DADN$$oa__"